import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_k8m6a3gz98: FaireBrandEntity = {
  token: "b_k8m6a3gz98",
  type: "brand",
  name: "212 SALSA",
  avatarUrl:
    "https://cdn.faire.com/fastly/9f5e50e2171ea4f537333fe2f85be2a8ff546dcaf212b44977a51404ae9bd245.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/aa7f3b504a41bd1a3823a958401bf99b45966d311ad58e5e99912a80a932b6ba.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/9f5e50e2171ea4f537333fe2f85be2a8ff546dcaf212b44977a51404ae9bd245.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/aa7f3b504a41bd1a3823a958401bf99b45966d311ad58e5e99912a80a932b6ba.jpeg",
  location: "New York, NY, USA",
  minimumOrderDollars: 372,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "Handmade in NYC, 212 SALSA was born to bring incredible fresh and refrigerated salsas to NYC and beyond.  Our salsas are constructed to be enormously fresh with delightful combinations of ingredients that don’t ruin the original flavor of the ingredient mixture for shelf life reasons.  The result is uniquely vibrant, smoky, premium-fresh salsas.",
  meta: {
    source: "api",
    importedAt: "2026-07-06T19:20:33.823Z",
    importedBy: "entity-db-cli",
  },
};
